<template>
  <el-card>
    <SweetTable ref="table" url="/erp/receipt/overpay/list" :before-table-binding="beforeTableBinding" :summaries-column="['needPayAmount','receiptAmount','overAmount']" api-version="v2" :is-page="false" :height="500">
      <el-table-column
          prop="orderCode"
          label="订单编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="factoryName"
          label="供应商"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="needPayAmount"
          label="应付金额"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="receiptAmount"
          label="开票金额"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="overAmount"
          label="超开金额"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
    </SweetTable>
  </el-card>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

export default {
  name: 'over-pay-card',
  mixins: [SweetTable],
  methods:{
    beforeTableBinding(dataList){
      dataList.forEach(row=>{
        row.overAmount=new BigNumber(row.receiptAmount).minus(row.needPayAmount).toFixed(2)
      })
    }
  }
}
</script>

<style scoped>

</style>
